import { api } from '../lib/axios';

export const nicheService = {
  async getAvailableNiches(status?: 'all' | 'enabled') {
    const params = status ? { status } : {};
    const response = await api.get('/niche', { params });
    return response.data;
  }
}; 